export function showTooltipOnTouch($this, event) {
	if (!$this.hasClass('is-touch') && !$this.children('.buttons-panel__link').hasClass('is-expand')) {
		event.preventDefault();

		$this
			.addClass('is-touch')
			.siblings()
			.removeClass('is-touch is-active');
	} else if ($this.hasClass('is-touch') && $this.children('.buttons-panel__link').hasClass('is-expand')) {
		$this.removeClass('is-touch');
	}
}

export function showTooltipOnHover(jsLink, jsShare, jsSocial, jsCompare) {
	$(jsLink).hover(function () {
		$(this).not('.is-expand').parent('.buttons-panel__item').addClass('is-active');

	}, function () {
		$(this).parent('.buttons-panel__item').removeClass('is-active');
	});

	$(`${jsShare}, ${jsSocial}, ${jsCompare}`).on('click', function (event) {
		$(this).parent('.buttons-panel__item').removeClass('is-active');
	});
}

export function toggleList(elem, options, currentList) {
	const $this = $(elem);

	if ($this.hasClass('is-expand')) {
		hideList($this, options, currentList);
	} else {
		showList($this, options);
	}
}

export function showList(elem, options) {
	if (elem.parent('.buttons-panel').hasClass('buttons-panel--with-shown-buttons')) {
		elem
			.addClass('is-expand')
			.siblings('.js-list')
			.addClass('is-expand')
			.find('.buttons-panel__link:not(.buttons-panel__link--shown-link)')
			.velocity(options.showEffect, options.durationEffect);
	} else {
		elem
			.addClass('is-expand')
			.siblings('.js-list')
			.addClass('is-expand')
			.velocity(options.showEffect, options.durationEffect);
	}
}

export function hideList(elem, options, list) {
	elem
		.removeClass('is-expand')
		.siblings('.js-list')
		.removeClass('is-expand');
	list
		.velocity(options.hideEffect, options.durationEffect);
}

export function showAndHideByTab($jsButtonsTrigger, toolListOptions, $jsButtonsList) {
	const TAB_KEY = 9;

	$('body').on('keyup', function (e) {
		if (e.which == TAB_KEY && $('.js-buttons-trigger:focus').length && !$jsButtonsTrigger.hasClass('is-expand')) {
			showList($jsButtonsTrigger, toolListOptions);
		} else if (e.which == TAB_KEY && $(e.target).is($jsButtonsTrigger, '.is-expand')) {
			hideList($jsButtonsTrigger, toolListOptions, $jsButtonsList);
		}
	});
}

export function sortTourSteps(steps, sorting) {
	return steps.sort((stepA, stepB) => (sorting.indexOf(stepA.id) > sorting.indexOf(stepB.id)) ? 1 : -1);
}



// WEBPACK FOOTER //
// ./temp/components/buttons-panel/functions.js